import { render, staticRenderFns } from "./AddExpense.vue?vue&type=template&id=3aa1a7cc"
import script from "./AddExpense.vue?vue&type=script&lang=js"
export * from "./AddExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports